import { Helmet } from "react-helmet-async";

const SITE_NAME = "Nityavastra";
const DEFAULT_DESC = "Handwoven sarees, bedsheets and home essentials from Banaras and Jaipur weavers. Sacred weaves, everyday grace. Ships across India.";
const DEFAULT_IMAGE = "https://customer-assets-lqy194kg.emergentagent.net/job_nityavastra-shop/artifacts/dirh3az1_Updated%20Logo%20Nityavastra.png";

/**
 * Reusable SEO tags block.
 *
 * @param {string} title - Page title (site name auto-appended unless `noSuffix`)
 * @param {string} description - Meta description (max ~160 chars)
 * @param {string} image - Absolute OG/Twitter image URL
 * @param {string} canonical - Absolute canonical URL for this page
 * @param {object|object[]} jsonLd - schema.org JSON-LD object(s) to embed
 * @param {boolean} noSuffix - Skip appending "— Nityavastra" to title
 * @param {boolean} noindex - Add noindex,nofollow directive
 */
export default function SEO({ title, description, image, canonical, jsonLd, noSuffix, noindex, type = "website", price, currency = "INR" }) {
  const fullTitle = title
    ? (noSuffix ? title : `${title} — ${SITE_NAME}`)
    : `${SITE_NAME} — Sacred weaves. Everyday grace.`;
  const desc = description || DEFAULT_DESC;
  const img = image || DEFAULT_IMAGE;
  const url = canonical || (typeof window !== "undefined" ? window.location.href : "");
  const ldArr = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {url && <link rel="canonical" href={url} />}
      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      {img && <meta property="og:image" content={img} />}
      {url && <meta property="og:url" content={url} />}
      <meta property="og:type" content={type} />
      {type === "product" && price !== undefined && price !== null && (
        <>
          <meta property="product:price:amount" content={String(price)} />
          <meta property="product:price:currency" content={currency} />
        </>
      )}
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {img && <meta name="twitter:image" content={img} />}
      {/* JSON-LD */}
      {ldArr.map((obj, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
}
